// extracted by mini-css-extract-plugin
export default {"AboutContainer":"About_AboutContainer__fkykv","AboutImgFrame":"About_AboutImgFrame__KPzE6","AboutImg":"About_AboutImg__Vtqux","AboutDescription":"About_AboutDescription__atnX0"};